import React, { useEffect, useState, useRef } from "react";
import logo from "../assets/logo4xp.png";
import notificationIcon from "../assets/bellb.png";
import userIcon from "../assets/userb.png";
import hamburger from "../assets/hamburger.png";
import { CgProfile } from "react-icons/cg";
import { IoNotificationsOutline } from "react-icons/io5";
import { useNotifications, avatarColor, parseBody } from "./NotificationContext";
import { IoIosSearch } from "react-icons/io";
import { socket } from "../socket";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Bell, BellDot, CircleUserRound } from "lucide-react";

const Header = ({ toggleSidebar }) => {
  const { addNotification } = useNotifications();
  const { notifications, clearNotifications } = useNotifications();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const orgName = sessionStorage.getItem('organizationName');
  const notificationsRef = useRef(null);
  const profileRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    const handleNotification = (notification) => {
      console.log("Notification received:", notification);
      
      addNotification(notification);
    };

    const handleNewChatRequest = (data) => {
      console.log("New chat request received:", data);
      const notification = {
        type: 'chat_request',
        title: 'New Chat Request',
        body: `${data.senderName}: ${data.message}`,
        chatId: data.chatId,
        clientId: data.clientId,
        organizationId: data.organizationId
      };
      addNotification(notification);
    };

    socket.on("notification", handleNotification);
    socket.on("newChatRequest", handleNewChatRequest);

    return () => {
      socket.off("notification", handleNotification);
      socket.off("newChatRequest", handleNewChatRequest);
    };
  }, [addNotification]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationsRef.current && !notificationsRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfile(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleNotificationClick = () => {
    setShowNotifications(!showNotifications);
  };

  const handleClearNotifications = () => {
    clearNotifications();
    setShowNotifications(false);
  };

  const handleProfileClick = () => {
    setShowProfile(!showProfile);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("adminId");
    navigate("/login");
  };

  const handleAcceptChat = (notification) => {
    const adminId = sessionStorage.getItem(`${orgName}_adminId`);
    console.log('Accepting chat', { adminId, notification });
    if (!adminId) return;

    socket.emit('acceptChat', {
      chatId: notification.chatId,
      adminId: adminId
    });

    // Navigate to chat window
    // navigate(`/chat/${notification.chatId}`);
    
    // Remove this notification
    const updatedNotifications = notifications.filter(
      n => !(n.type === 'chat_request' && n.chatId === notification.chatId)
    );
    clearNotifications();
    updatedNotifications.forEach(n => addNotification(n));
    
    setShowNotifications(false);
  };

  return (
    <>
      <div className="flex top-0 items-center justify-between p-2 bg-gray-100">
        <div className="flex items-center ml-5">
          <img
            src={logo}
            alt="logo"
            className="w-20 p-1 h-auto cursor-pointer"
          />
        </div>
        {/* <div className="relative flex-grow flex justify-center">
          <input
            type="search"
            placeholder="Search..."
            className="w-[300px] ml-10 max-sm:ml-3 rounded-lg h-10
             p-3 max-sm:hidden bg-gray-300 pl-10 " // Added padding-left for the icon
          />
          <div className="absolute mr-[215px] mt-[11px]">
            <IoIosSearch className="w-5 h-5 text-gray-500 max-sm:hidden" />
          </div>
        </div>   */}
        <div className="flex items-center pr-2">
          <div className="relative mr-3">
            <Bell
              onClick={handleNotificationClick}
              className="w-10 h-auto p-2 cursor-pointer bg-blue-800 hover:bg-blue-900 text-white rounded-full"
            />
            {notifications.length > 0 && (
              <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 shadow-md ring-2 ring-white pointer-events-none">
                {notifications.length > 99 ? "99+" : notifications.length}
              </span>
            )}
          </div>

          <CircleUserRound
            onClick={handleProfileClick}
            className="p-2 w-10 h-auto cursor-pointer bg-blue-800 hover:bg-blue-900 text-white rounded-full"/>

          {/* <CgProfile
            onClick={handleProfileClick}
            className="w-10 h-auto p-2  cursor-pointer bg-blue-800 hover:bg-blue-900 text-white rounded-full"
          /> */}
          <img
            src={hamburger}
            alt="hamburger"
            onClick={toggleSidebar}
            className="w-8 ml-5 md:hidden lg:hidden min-md:hidden hover:cursor-pointer"
          />
        </div>
        {showNotifications && (
          <div
            ref={notificationsRef}
            className="absolute z-10 right-4 top-16 bg-white border border-gray-200 rounded-2xl w-80 shadow-2xl flex flex-col overflow-hidden"
          >
            {/* Header */}
            <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
              <span className="text-sm font-bold text-gray-800">Notifications</span>
              {notifications.length > 0 && (
                <span className="text-xs bg-red-100 text-red-500 font-semibold px-2 py-0.5 rounded-full">
                  {notifications.length} new
                </span>
              )}
            </div>

            {/* List */}
            <ul className="overflow-y-auto max-h-72 divide-y divide-gray-100">
              {notifications.length === 0 && (
                <li className="px-4 py-8 text-center text-sm text-gray-400">
                  No notifications
                </li>
              )}
              {notifications.map((notification, index) => {
                const hasSender = Boolean(notification.senderName);
                const message = hasSender
                  ? parseBody(notification.body, notification.senderName)
                  : notification.body;

                return (
                  <li
                    key={index}
                    className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors"
                  >
                    {/* Avatar */}
                    {hasSender ? (
                      <div
                        className={`flex-shrink-0 w-10 h-10 rounded-full ${avatarColor(notification.senderName)} flex items-center justify-center text-white font-semibold text-sm select-none`}
                      >
                        {notification.senderName.charAt(0).toUpperCase()}
                      </div>
                    ) : (
                      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center">
                        <Bell className="w-5 h-5 text-white" />
                      </div>
                    )}

                    {/* Text */}
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-bold text-gray-900 truncate">
                        {hasSender ? notification.senderName : notification.title}
                      </p>
                      {message && (
                        <p className="text-xs text-gray-500 truncate mt-0.5">{message}</p>
                      )}
                      {notification.type === "chat_request" && (
                        <button
                          onClick={() => handleAcceptChat(notification)}
                          className="mt-1.5 bg-dark-red text-white text-xs px-3 py-1 rounded-md hover:bg-red-700 transition-colors"
                        >
                          Accept Chat
                        </button>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>

            {/* Footer */}
            <button
              onClick={handleClearNotifications}
              className="w-full bg-blue-800 hover:bg-blue-900 text-white text-sm font-medium py-2.5 transition-colors"
            >
              Clear all
            </button>
          </div>
        )}
        {showProfile && (
          <div 
            ref={profileRef}
            className="absolute right-4 top-16 bg-white border border-gray-300 rounded-lg w-28 h-22  shadow-lg flex flex-col"
          >
            <ul className="overflow-y-auto">
              <li className="p-2 border-b border-gray-200 hover:text-white  hover:bg-blue-800">
                <Link to="profile" >Settings</Link>
              </li>
            </ul>
            <ul className="overflow-y-auto">
              <li className="p-2 border-b border-gray-200 hover:text-white  hover:bg-blue-800">
                <button onClick={handleLogout}>Logout</button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
